const BOT_BASE_URL = 'https://ut-ka.ru/api';

/**
 * Отправляет приватное сообщение пользователю по chatId
 * @param {string} targetUser - chat ID пользователя
 * @param {Object} message - объект с полями type, content, caption
 * @returns {Promise<{success: boolean, error?: string}>}
 */
export async function sendPrivateMessage(targetUser, message) {
  if (!targetUser || !message?.content?.trim()) {
    throw new Error('Не указан chat ID или содержимое сообщения');
  }

  const body = {
    targetUser,
    message,
  };

  // Меняем endpoint на Express API
  const response = await fetch(`${BOT_BASE_URL}/send-message`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });

  if (!response.ok) {
    throw new Error(`Ошибка сервера: ${response.statusText}`);
  }

  const data = await response.json();
  if (!data.success) {
    throw new Error(data.error || 'Неизвестная ошибка при отправке');
  }

  return data;
}